import React from "react";
import { StyleSheet, View } from "react-native";
import Text from "@components/CustomText";
import PrimaryButton from "@components/PrimaryButton";
import color from "@constants/color";
import { GIGS_COPY } from "../copy";

interface SummaryBarProps {
  summaryText: string;
  confirmEnabled: boolean;
  submitting: boolean;
  onConfirm: () => void;
}

/** Sticky bottom bar: running "N yes · N no · N pending" + Confirm. */
const SummaryBar: React.FC<SummaryBarProps> = ({
  summaryText,
  confirmEnabled,
  submitting,
  onConfirm,
}) => {
  return (
    <View style={styles.container}>
      <Text variant="body_text_2" style={styles.summaryText} numberOfLines={1}>
        {summaryText}
      </Text>
      <PrimaryButton
        testID="gigs-confirm-button"
        text={
          submitting ? GIGS_COPY.marking.submitting : GIGS_COPY.marking.confirm
        }
        loading={submitting}
        disabled={!confirmEnabled}
        onPress={onConfirm}
        buttonStyle={styles.confirmButton}
        textStyle={styles.confirmButtonText}
      />
    </View>
  );
};

export default SummaryBar;

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderTopWidth: 1,
    borderTopColor: color.lineColor,
    backgroundColor: color.white,
    gap: 12,
  },
  summaryText: {
    flex: 1,
    color: color.mediumBlack,
  },
  confirmButton: {
    minWidth: 120,
    paddingHorizontal: 24,
    paddingVertical: 10,
  },
  confirmButtonText: {
    fontSize: 16,
    lineHeight: 20,
  },
});
